import { date, object, string } from 'yup'
import dayjs from 'dayjs'
import { maxYearsValidator } from '@/utils/maxYearsValidator'

export const CreateValidateSchema = object().shape({
	bin: string().required({ key: 'required' }).nullable(),
	contractDate: string()
		.required({ key: 'required' })
		.nullable()
		.test(maxYearsValidator(50, { key: 'labor.date.min' })),
	beginDate: string()
		.required({ key: 'required' })
		.nullable()
		.test(maxYearsValidator(50, { key: 'labor.date.min' })),
	endDate: string()
		.nullable()
		.test(
			'is-before-beginDate',
			{ key: 'contracts_civil_low.end_date_before_start' },
			function(value) {
				const { beginDate } = this.parent
				if (value && beginDate) {
					return dayjs(beginDate, 'DD.MM.YYYY').isBefore(dayjs(value, 'DD.MM.YYYY'))
				} else {
					return true
				}
			},
		),
	iin: string()
		.nullable()
		.min(12, { key: 'min_length', value: 12 })
		.max(12, { key: 'max_length', value: 12 })
		.test(
			'bin-iin-check',
			{ key: 'iin_bin_error_employer' },
			function(value) {
				const { bin } = this.parent
				if (value && bin) {
					return bin !== value
				} else {
					return true
				}
			},
		),
	companyName: string().required({ key: 'required' }).nullable(),
	companyNameKaz: string().required({ key: 'required' }).nullable(),
	contractNumber: string().required({ key: 'required' }).nullable(),
	fullName: string().required({ key: 'required' }).nullable(),
})
